// extracted by mini-css-extract-plugin
export var notificationHost = "_i5-0";